<template>
  <div class="container">
    <van-sticky>
      <div class="subtitle">
        <select-mu-wei ref="selectMuWei" />
      </div>
    </van-sticky>
    <van-checkbox-group
      ref="checkboxGroup"
      class="list-wrap"
      v-model="result"
      @change="checkChange"
      v-if="list.length !== 0"
    >
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div
          class="list-item"
          @click="itemClick(item)"
          v-for="item in list"
          :key="item.id"
        >
          <van-checkbox
            class="list-item_checkbox"
            :name="item.id"
            ref="checkboxes"
          />
          <img
            class="list-item_left"
            :src="item.tradeCoverPhoto"
            @click.stop="handleView(item)"
          />
          <div class="list-item_right">
            <div>{{ item.tradeName }}</div>
            <div>￥ {{ item.price }}</div>
            <div @click.stop="">
              <van-stepper v-model="item.amount" :disabled="true" />
            </div>
            <van-icon
              class="delete-icon"
              size="20"
              name="delete-o"
              @click.stop="handleDel(item.id)"
            />
          </div>
        </div>
      </van-list>
    </van-checkbox-group>
    <van-empty description="尚未添加购物车" v-else />
    <van-submit-bar
      :price="totalPrice * 100"
      button-text="提交订单"
      @submit="onSubmit"
    >
      <van-checkbox v-model="checked" @click="checkAll">全选</van-checkbox>
    </van-submit-bar>
  </div>
</template>

<script>
import { getCartList, delCart,countGraveArrearsForOrder } from '@/api/good';
import { Toast, Dialog } from 'vant';
import selectMuWei from '@/components/selectMuWei';

export default {
  name: 'shoppingCart',
  components: { selectMuWei },
  computed: {
    // totalPrice() {
    //   // let total = 0;
    //   // for (let i = 0; i < this.result.length; i++) {
    //   //   let index = this.result[i];
    //   //   total += this.list[index].price;
    //   // }
    //   // return total;
    //   return 100000;
    // },
  },
  data() {
    return {
      result: [],
      checked: false,
      quantity: [],
      loading: false,
      finished: false,
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      list: [],
      // show: false,
      totalPrice: 0,
      // cartList: [
      //   {
      //     id: 1,
      //     name: '商品1',
      //     price: 100,
      //     count: 1,
      //     imgUrl: '@/assets/img1.jpg',
      //   },
      //   {
      //     id: 2,
      //     name: '商品2',
      //     price: 200,
      //     count: 2,
      //     imgUrl: '@/assets/img2.jpg',
      //   },
      //   {
      //     id: 3,
      //     name: '商品3',
      //     price: 300,
      //     count: 1,
      //     imgUrl: '@/assets/img3.jpg',
      //   },
      //   {
      //     id: 4,
      //     name: '商品3',
      //     price: 300,
      //     count: 1,
      //     imgUrl: '@/assets/img3.jpg',
      //   },
      //   {
      //     id: 5,
      //     name: '商品3',
      //     price: 300,
      //     count: 1,
      //     imgUrl: '@/assets/img3.jpg',
      //   },
      // ],
      maintenance:{}
    };
  },
  created() {
    this.init();
  },
  activated() {
    this.show = false;
    if (!this.show) {
      setTimeout(() => {
        this.show = true;
      }, 0);
    }
  },
  methods: {
    itemClick(obj) {
      if (this.result.includes(+obj.id)) {
        const index = this.result.findIndex((i) => i === +obj.id);
        this.result.splice(index, 1);
      } else {
        this.result.push(+obj.id);
      }
      console.log(this.result);
    },
    onSubmit() {
      if (this.result.length > 0) {
        let ids = this.result.join(',');
        this.$router.push({ name: 'orderConfirm', query: { ids,type:'shoppingCart', } });
      }else{
        Toast.fail('请至少选择一个商品!');
      }
    },
    checkAll() {
      if (this.list.length === 0) {
        return;
      }
      this.$refs.checkboxGroup.toggleAll(this.checked);
    },
    checkChange() {
      let checkboxes = this.$refs.checkboxes;
      // let result = checkboxes
      //   .filter((checkbox) => checkbox.checked)
      // .map((checkbox) => checkbox.name);
      let totalPrice = 0;
      checkboxes.forEach((i) => {
        if (i.checked) {
          const obj = this.list[i.index];
          const price = Number(obj.amount) * Number(obj.price).toFixed(2);
          totalPrice = price + totalPrice;
        }
      });
      this.$set(this,'totalPrice',totalPrice);
      if (this.result.length === this.list.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    handleDel(ids) {
      Dialog.confirm({
        title: '提示',
        message: '确定删除该数据吗？',
      })
        .then(() => {
          delCart(ids).then(() => {
            Toast.success('删除成功!');
            this.init();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    handleView(item) {
      this.$router.push({
        name: 'goodsDetail',
        query: { id: item.commodityId },
      });
    },
    init() {
      this.page.currentPage = 1;
      this.list = [];
      this.finished = false;
      this.onLoad();
    },
    onLoad(page = this.page) {
      this.loading = true;
      getCartList(page.currentPage, page.pageSize, this.query).then((res) => {
        const { rows } = res;
        rows.forEach((item,i)=>{
          if(+item.commodityId === 0){
            const index = (page.pageSize * (page.currentPage -1)) + Number(i);
            this.getCalculation(item.tombLocationId,item.id,index)
          }
        })
        if (this.page.currentPage == 1) {
          this.list = rows;
        } else {
          this.list = [...this.list, ...rows];
        }
        this.page.currentPage++;
        this.loading = false;
        if (this.list.length >= res.total) {
          this.finished = true;
        }
      });
    },
    getCalculation(graveBuyId,id,index){
      const loading = this.$loading({
          lock: true,
          text: '计算综合服务费中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        countGraveArrearsForOrder({ gGBId: graveBuyId }).then(
          (res) => {
            this.maintenance[id] = res.data;
            this.$set(this.list[index],'price',res.data.totalFee)
            loading.close();
          }
        );
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 105px;
  .subtitle {
    padding-left: 12px;
    line-height: 40px;
    background: #fff;
    margin-bottom: 10px;
    position: relative;
    padding-left: 18px;
    &::before {
      content: '';
      position: absolute;
      left: 5px;
      top: 50%;
      transform: translateY(-50%);
      width: 8px;
      height: 16px;
      background: #67c23a;
      border-radius: 2px;
    }
  }
  .list-wrap {
    .list-item {
      padding: 30px 12px 8px;
      height: 150px;
      box-sizing: border-box;
      display: flex;
      background: #fff;
      margin-bottom: 10px;
      position: relative;
      .delete-icon {
        position: absolute;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
      }
      .list-item_checkbox {
        position: absolute;
        left: 12px;
        top: 5px;
      }
      .list-item_left {
        width: 150px;
        height: 100%;
        padding-right: 10px;
      }
      .list-item_right {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        div:nth-child(1) {
          height: 25px;
          line-height: 25px;
          font-size: 16px;
          font-weight: bold;
          color: #303133;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        div:nth-child(2) {
          height: 35px;
          line-height: 35px;
          font-size: 20px;
          color: #465cff;
          font-weight: 900;
        }
        div:nth-child(3) {
          font-size: 14px;
          color: #606266;
          overflow: hidden;
          text-overflow: ellipsis;
          // flex: 1;
        }
      }
    }
  }
}
::v-deep .van-submit-bar {
  bottom: 55px;
}
</style>
